import React from 'react';
import { ProfileIcon } from '../../UserManagement/ProfileIcon.tsx';

const PatientAppointmentDetailsHeader = ({ selectedAppointment }) => {
    return (
        <div className="flex flex-col items-center mb-6">
            <div className="mb-3 w-16 h-16">
                <ProfileIcon />
            </div>
            {selectedAppointment.created_by_user && (
                <div className="text-xl font-semibold text-gray-800 text-center">
                    {selectedAppointment.created_by_user.firstname + ' ' + selectedAppointment.created_by_user.lastname}
                </div>
            )}
        </div>
    );
};

export default PatientAppointmentDetailsHeader;
